import {SET_COST_CENTER, SET_COST_CENTERS} from "../../constants/costCenterConstants"


export const setCostCenter = (costCenter) => {
  return {
    type: SET_COST_CENTER,
    costCenter
  }
}


export const setCostCenters = (costCenters,filtered=false) => {
  return {
    type: SET_COST_CENTERS,
    costCenters,
    filtered
  }
}